export function startBrowserNavigationProtection() {
  let restoredFromCache = false;

  window.shouldPreventAutomaticReload = () => {
    const navigation = performance.getEntriesByType('navigation')[0];
    return restoredFromCache || navigation?.type === 'back_forward';
  };

  window.addEventListener('pagehide', (event) => {
    // Protect the cached page before visibilitychange fires on restoration.
    if (event.persisted) {
      restoredFromCache = true;
    }
  });

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      restoredFromCache = true;
    }
  });
}
